export default function(t,e,i,n,r){for(r in n=(i=i.split(".")).splice(-1,1),i)e=e[i[r]]=e[i[r]]||{};return t(e,n)};
//# sourceMappingURL=deepobj.m.js.map
